import CryptoJS from 'crypto-js';

import { USUARIO_CONFIGS } from '@/shared/constants/strings';

export const USER_CONFIGS_KEY = import.meta.env.VITE_USER_CONFIGS_KEY as string;

import { NavigationView } from '@/shared/constants/navigation-view.enum';

export class UsuarioConfigs {
  username?: string;

  nome?: string;

  modulo?: number;

  cor_fundo_zebrado_tabela: string;

  cor_fonte_zebrado_tabela: string;

  navbar: boolean;
  cpf?: string;

  /** ID da pessoa vinculada ao usuário logado. */
  pessoaId?: string;

  /** ID do usuário logado (login tradicional). */
  userId?: number;

  /** Visão simulada para testes (usuário id 2). */
  navigationViewOverride?: NavigationView;

  private static normalize(configs: UsuarioConfigs): UsuarioConfigs {
    return {
      ...configs,
      cor_fundo_zebrado_tabela: configs.cor_fundo_zebrado_tabela ?? '',
      cor_fonte_zebrado_tabela: configs.cor_fonte_zebrado_tabela ?? '',
      navbar: configs.navbar ?? false,
    };
  }

  static GetConfigs(): UsuarioConfigs | null {
    try {
      const encryptedData = localStorage.getItem(USUARIO_CONFIGS);
      if (!encryptedData) return null;

      if (!USER_CONFIGS_KEY) {
        localStorage.removeItem(USUARIO_CONFIGS);
        return null;
      }

      const bytes = CryptoJS.AES.decrypt(encryptedData, USER_CONFIGS_KEY);
      const plain = bytes.toString(CryptoJS.enc.Utf8).trim();
      if (!plain) {
        localStorage.removeItem(USUARIO_CONFIGS);
        return null;
      }

      return this.normalize(JSON.parse(plain) as UsuarioConfigs);
    } catch (error) {
      console.error('Erro ao descriptografar configurações:', error);
      localStorage.removeItem(USUARIO_CONFIGS);
    }
    return null;
  }

  static SetConfigs(configs: UsuarioConfigs) {
    try {
      if (!USER_CONFIGS_KEY) return;
      const normalized = this.normalize(configs);
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(normalized),
        USER_CONFIGS_KEY,
      ).toString();
      localStorage.setItem(USUARIO_CONFIGS, encrypted);
    } catch (error) {
      console.error('Erro ao criptografar configurações:', error);
    }
  }
}
